var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6336_22456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#EBEBEB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6336_22456)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6336_22456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.643 15.2881H10.1642C8.52069 15.2881 6.94449 15.9303 5.78234 17.0734C4.62019 18.2166 3.96729 19.767 3.96729 21.3836V23.8218H18.8399V21.3836C18.8399 19.767 18.187 18.2166 17.0249 17.0734C15.8627 15.9303 14.2865 15.2881 12.643 15.2881Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4035 14.068C13.4569 14.068 15.1216 12.4306 15.1216 10.4107C15.1216 8.39085 13.4569 6.75342 11.4035 6.75342C9.34998 6.75342 7.6853 8.39085 7.6853 10.4107C7.6853 12.4306 9.34998 14.068 11.4035 14.068Z",
    fill: "#484848"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6336_22456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5655,
    height: 18.0714,
    fill: "white",
    transform: "translate(3.52734 5.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.9d87fe97f8410904239abdf913aee7fd.svg";
export { ForwardRef as ReactComponent };